import { channelDisplayName } from "@redotech/redo-merchant-support-app/utils";
import { ConversationPlatform } from "@redotech/redo-model/conversation";
import { RuleTypeDetailsProps } from "@redotech/redo-return-ui/flows/rules/multiple-actions";
import { TicketChannelState } from "@redotech/redo-return-ui/flows/rules/ticket-channel";
import { RedoFilterDropdownAnchor } from "@redotech/redo-web/arbiter-components/filter-group/redo-filter-group";
import { RedoMultiselectDropdown } from "@redotech/redo-web/arbiter-components/list/redo-multiselect-dropdown";
import { Flex } from "@redotech/redo-web/flex";
import { memo, useMemo, useState } from "react";
import * as conditionsCss from "./conditions.module.css";

const channels = [
  ConversationPlatform.EMAIL,
  ConversationPlatform.FACEBOOK,
  ConversationPlatform.INSTAGRAM,
  ConversationPlatform.INSTAGRAM_COMMENTS,
  ConversationPlatform.FACEBOOK_COMMENTS,
  ConversationPlatform.REDO_CHAT,
  ConversationPlatform.ATTENTIVE,
  ConversationPlatform.POSTSCRIPT,
  ConversationPlatform.TIKTOK,
];

export const TicketChannelDetails = memo(function TicketChannelDetails({
  state,
  setState,
  disabled,
}: RuleTypeDetailsProps<TicketChannelState>) {
  const [dropdownButtonRef, setDropdownButtonRef] =
    useState<HTMLButtonElement | null>(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const channelItems = useMemo(() => {
    return channels.map((channel) => ({
      id: channel,
      type: "text" as const,
      text: channelDisplayName(channel),
      value: channel,
    }));
  }, []);

  const selectedItems = useMemo(() => {
    return state.map((channel) => ({
      id: channel,
      type: "text" as const,
      text: channelDisplayName(channel),
      value: channel,
    }));
  }, [state]);

  const displayText =
    state.length > 0
      ? state.length === 1
        ? // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
          channelDisplayName(state[0])
        : `${state.length} channels selected`
      : "Select channels";

  return (
    <Flex dir="column" gap="sm" w="full">
      <div style={{ fontSize: "12px", color: "#666" }}>Channel</div>
      <RedoFilterDropdownAnchor
        className={conditionsCss.fullWidthButton}
        color={disabled ? "tertiary" : "primary"}
        onClick={() => {
          if (!disabled) {
            setDropdownOpen(!dropdownOpen);
          }
        }}
        ref={setDropdownButtonRef}
        text={displayText}
      />
      <RedoMultiselectDropdown
        dropdownAnchor={dropdownButtonRef}
        dropdownOpen={dropdownOpen}
        fitToAnchor
        items={channelItems}
        selectedItems={selectedItems}
        selectionVariant="checkbox"
        setDropdownOpen={setDropdownOpen}
        setSelectedItems={(items) => {
          setState(items.map((item) => item.value));
        }}
        size="xs"
      />
    </Flex>
  );
});
